import { getApiBaseURL } from './apiUrl';

/** Нормализация строки для сопоставления ФИО / логина с данными из /api/users */

export function normalizePersonNameKey(s) {
  return String(s || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** Привести путь/URL аватарки к виду, пригодному для src */
export function normalizeAvatarUrl(url) {
  if (!url || typeof url !== 'string') return null;
  let trimmed = url.trim();
  trimmed = trimmed.replace(/\\/g, '/');
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  const idx = trimmed.toLowerCase().indexOf('/uploads/avatars/');
  if (idx !== -1) return trimmed.slice(idx);
  if (!trimmed) return null;
  if (trimmed.startsWith('/uploads') || trimmed.startsWith('/images')) return trimmed;
  if (trimmed.startsWith('uploads/')) return '/' + trimmed;
  return '/uploads/avatars/' + trimmed.replace(/^\/+/, '');
}

/**
 * URL для <img src>: при dev (клиент :3001, API :5000) относительный путь иначе уходит на webpack, а не на сервер с файлами.
 */
export function avatarSrcForImg(url) {
  const path = normalizeAvatarUrl(url);
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const base = String(getApiBaseURL() || '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}

/** Карта нормализованное имя/логин → сырой avatar из users (в т.ч. ФИО как в личном кабинете и «Фамилия Имя») */
export function buildAppUsersAvatarLookupMap(appUsers) {
  const m = new Map();
  const addKey = (label, av) => {
    const k = normalizePersonNameKey(label);
    if (k && !m.has(k)) m.set(k, av);
  };
  for (const u of appUsers || []) {
    const av = String(u?.avatar || '').trim();
    if (!av) continue;
    if (u.username) addKey(u.username, av);
    if (u.fio) {
      addKey(u.fio, av);
      const parts = String(u.fio).trim().split(/\s+/).filter(Boolean);
      if (parts.length >= 2) {
        addKey(`${parts[parts.length - 1]} ${parts[0]}`, av);
      }
    }
  }
  return m;
}

function collectNameKeysForReportRow(row) {
  const keys = [];
  const add = (s) => {
    const k = normalizePersonNameKey(s);
    if (k) keys.push(k);
  };
  const addWindowsStyle = (s) => {
    if (!s || typeof s !== 'string') return;
    add(s);
    const backslash = s.indexOf('\\');
    if (backslash !== -1) add(s.slice(backslash + 1));
    const at = s.indexOf('@');
    if (at !== -1) add(s.slice(0, at));
  };
  if (row?.username) addWindowsStyle(row.username);
  if (row?.technicalUsername) addWindowsStyle(row.technicalUsername);
  if (row?.fio) add(row.fio);
  if (row?.realUsername) add(row.realUsername);
  const fio = String(row?.fio || '').trim();
  const parts = fio.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    add(`${parts[parts.length - 1]} ${parts[0]}`);
  }
  return [...new Set(keys)];
}

/** Подобрать avatar для строки отчёта (удалёнка / локальные ПК) по users */
export function resolveAvatarFromUserMap(row, map, displayFioExtra) {
  if (!map || map.size === 0) return null;
  const rowsToTry = [row];
  if (displayFioExtra && String(displayFioExtra).trim() && displayFioExtra !== row?.fio) {
    rowsToTry.push({ ...row, fio: displayFioExtra });
  }
  for (const r of rowsToTry) {
    for (const k of collectNameKeysForReportRow(r)) {
      const a = map.get(k);
      if (a) return a;
    }
  }
  return null;
}
